import type { HTMLAttributes, JSX } from "react";

import { cn } from "@/lib/utils";

export type BadgeVariant = "default" | "muted" | "info" | "success" | "warning" | "destructive";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: "bg-primary/10 text-primary",
  muted: "bg-muted text-muted-foreground",
  info: "bg-brand-alert-info-00 text-brand-alert-info-10",
  success: "bg-brand-alert-success-00 text-brand-alert-success-10",
  warning: "bg-brand-alert-warning-00 text-brand-alert-warning-10",
  destructive: "bg-brand-alert-error-00 text-brand-alert-error-10",
};

export function Badge({ className, variant = "default", ...props }: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-body-3 font-medium",
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  );
}
